import { render } from "./CollapseSection.vue?vue&type=template&id=57ed9a6c"
import script from "./CollapseSection.vue?vue&type=script&lang=js"
export * from "./CollapseSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__